// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n1-9";
export var arrowButtonContainer = "_n1-5";
export var arrowButtonIcon = "_n1-6";
export var carouselArrowButton = "_n1-2";
export var carouselElementContainer = "_n1-1";
export var currentSlide = "_n1-8";
export var left = "_n1-3";
export var otherSlide = "_n1-a";
export var productCarouselContainer = "_n1-0";
export var right = "_n1-4";
export var sliderOverflow = "_n1-7";